const Google = ({
  width = 20,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1528 8.63672V11.5413H14.2716C14.0907 12.4754 13.548 13.2663 12.734 13.7981L15.2177 15.6868C16.6649 14.3777 17.4998 12.455 17.4998 10.1709C17.4998 9.63908 17.4511 9.12767 17.3606 8.6368L10.1528 8.63672Z"
        fill="#4285F4"
      />
      <path
        d="M3.32091 6.63867C2.79914 7.64773 2.5 8.78639 2.5 10C2.5 11.2136 2.79914 12.3523 3.32091 13.3613C3.32091 13.3681 5.86735 11.425 5.86735 11.425C5.71429 10.975 5.62382 10.4977 5.62382 9.99993C5.62382 9.50214 5.71429 9.02489 5.86735 8.57489L3.32091 6.63867Z"
        fill="#FBBC05"
      />
      <path
        d="M10.1529 5.48638C11.28 5.48638 12.2818 5.86819 13.0819 6.60457L15.2735 4.45685C13.9446 3.24323 12.2192 2.5 10.1529 2.5C7.16123 2.5 4.58008 4.1841 3.3208 6.63866L5.86716 8.57504C6.47242 6.80228 8.16308 5.48638 10.1529 5.48638Z"
        fill="#EA4335"
      />
      <path
        d="M5.86387 11.4277L5.30368 11.848L3.3208 13.3616C4.58008 15.8093 7.16107 17.5003 10.1527 17.5003C12.219 17.5003 13.9514 16.8321 15.2176 15.6866L12.7339 13.798C12.052 14.248 11.1824 14.5207 10.1527 14.5207C8.16292 14.5207 6.47233 13.2048 5.867 11.4321L5.86387 11.4277Z"
        fill="#34A853"
      />
    </svg>
  );
};

export default Google;
